import { API } from '~/api/api';
import type { RequestParams } from '~/interfaces/api';

export async function SearchMatch(params: RequestParams) {
  try {
    const res = await API.get('/search/match', params);
    return res.data;
  } catch (error) {
    // console.error('SearchMatch error');
    return null;
  }
}

export async function SearchSuggests(params: RequestParams) {
  try {
    const res = await API.get('/suggests', params);
    return res.data;
  } catch (error) {
    // console.error('SearchMatch error');
    return null;
  }
}
